import Icon from '../../../components/AppIcon';

const AffiliateProgram = () => {
  const levels = [
    {
      id: 1,
      level: "Nivel 1",
      commission: "20%",
      description: "Gana el 20% de comisión por cada persona que se registre usando tu enlace de referido directo",
      icon: "UserPlus",
      color: "bg-primary",
      textColor: "text-primary-foreground",
      example: "Si tu referido paga $50.000 COP, ganas $10.000 COP"
    },
    {
      id: 2,
      level: "Nivel 2",
      commission: "10%",
      description: "Gana el 10% adicional cuando tus referidos directos refieren a otras personas",
      icon: "Users",
      color: "bg-secondary",
      textColor: "text-secondary-foreground",
      example: "Si el referido de tu referido paga $50.000 COP, ganas $5.000 COP"
    }
  ];

  return (
    <section className="py-12 sm:py-14 md:py-16 lg:py-20 px-4 sm:px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 md:mb-14 lg:mb-16">
          <div className="inline-flex items-center gap-1.5 sm:gap-2 bg-accent text-accent-foreground px-3 sm:px-3.5 md:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-bold mb-3 sm:mb-4">
            <Icon name="TrendingUp" size={14} className="sm:hidden" />
            <Icon name="TrendingUp" size={16} className="hidden sm:block" />
            <span>PROGRAMA DE AFILIADOS</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-3 sm:mb-4 px-2">
            Programa de Afiliados en Dos Niveles
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto px-4">
            Gana dinero refiriendo amigos y construye tu red de ingresos pasivos
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6 md:gap-7 lg:gap-8">
          {levels?.map((level) => (
            <div
              key={level?.id}
              className={`${level?.color} ${level?.textColor} rounded-xl sm:rounded-2xl p-5 sm:p-6 md:p-7 lg:p-8 shadow-lg`}
            >
              <div className="flex items-center gap-3 sm:gap-3.5 md:gap-4 mb-4 sm:mb-5 md:mb-6">
                <div className="flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-white/20 rounded-lg sm:rounded-xl">
                  <Icon name={level?.icon} size={24} className="sm:hidden" />
                  <Icon name={level?.icon} size={28} className="hidden sm:block md:hidden" />
                  <Icon name={level?.icon} size={32} className="hidden md:block" />
                </div>
                <div>
                  <div className="text-xs sm:text-sm font-medium opacity-90">{level?.level}</div>
                  <div className="text-2xl sm:text-3xl md:text-4xl font-bold">{level?.commission}</div>
                </div>
              </div>

              <p className="text-sm sm:text-base md:text-lg mb-3 sm:mb-3.5 md:mb-4 opacity-90">
                {level?.description}
              </p>

              <div className="bg-white/10 rounded-lg p-3 sm:p-3.5 md:p-4">
                <div className="flex items-start gap-1.5 sm:gap-2">
                  <Icon name="Calculator" size={18} className="sm:hidden flex-shrink-0 mt-0.5" />
                  <Icon name="Calculator" size={20} className="hidden sm:block flex-shrink-0 mt-0.5" />
                  <div>
                    <div className="text-xs sm:text-sm font-medium mb-0.5 sm:mb-1">Ejemplo:</div>
                    <div className="text-xs sm:text-sm opacity-90">{level?.example}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AffiliateProgram;